module.exports = `${require.publicPath}banner-img02.4433c27a.png`;